<template>
    <v-btn class="mb-1 ms-auto" to="/docs/" target="_blank">
        <v-icon left class="mr-2">
            mdi-information
        </v-icon>
        Documentation
    </v-btn>
</template>